var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPowerBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9799 2.6765V61.2838C47.9799 62.7402 46.7991 63.9603 45.3034 63.9603H28.654C27.1977 63.9603 25.9775 62.7795 25.9775 61.2838V2.6765C25.9775 1.22017 27.1583 0 28.654 0H45.3034C46.7597 0.0393602 47.9799 1.22017 47.9799 2.6765Z",
    fill: "url(#paint0_linear_567_1593)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9916 18.696V63.9996H12.9893V18.696C12.9893 17.2397 14.1701 16.0195 15.6658 16.0195H32.3151C33.7714 16.0195 34.9916 17.2003 34.9916 18.696Z",
    fill: "url(#paint1_linear_567_1593)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.6765V61.3234C0 62.7797 1.18081 63.9998 2.67649 63.9998H22.0024V34.6765C22.0024 33.2202 20.8216 32 19.3259 32H2.67649C1.22017 32 0 33.1808 0 34.6765Z",
    fill: "url(#paint2_linear_567_1593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_1593",
    x1: 22.349,
    y1: 0.0137363,
    x2: 49.9075,
    y2: 60.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E35EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#932A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_567_1593",
    x1: 11.794,
    y1: 16.6143,
    x2: 35.0098,
    y2: 63.0459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A844EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A82BBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_567_1593",
    x1: 3.82184,
    y1: 30.4397,
    x2: 16.6053,
    y2: 61.6831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B251EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03DC5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBi);
export default __webpack_public_path__ + "static/media/power-bi.5c8059d588184ad7a1216352400d20a3.svg";
export { ForwardRef as ReactComponent };